import { Box, Button, Typography } from "@mui/material";

const SectionCard = ({ title, description, children, actions }) => {
    return (
        <Box mb={1} p={2} pr={0} border="1px solid #eee" sx={{ bgcolor: "#F6F8F9" }}>
            <Box display="flex" justifyContent="space-between" alignItems="center">
                <Box>
                    <Typography variant="h4" mb={1} sx={{
                        fontFamily: "Outfit, sans-serif",
                        fontWeight: 500,
                        fontSize: '20px',
                        letterSpacing: "0px",
                        mb: 0,
                        color: "#111216"
                    }}>
                        {title}
                    </Typography>
                    <Typography variant="h6" mb={1} sx={{
                        fontFamily: "Outfit, sans-serif",
                        fontWeight: 500,
                        fontSize: '14px',
                        letterSpacing: "0px",
                        color: '#7D7F81'
                    }}>
                        {description}
                    </Typography>
                </Box>
                {/* {actions?.length > 0 && (
                    <Box display="flex" gap={1}>
                        {actions.map((btn, index) => (
                            <Button
                                key={index}
                                variant="contained"
                                size="small"
                                onClick={btn.onClick}
                                sx={{
                                    background: "#e0f7ff",
                                    color: "#5995d5",
                                    fontSize: "12px",
                                    lineHeight: "100%",
                                    minWidth: "230px",
                                    padding: "10px 20px",
                                    fontWeight: 800,
                                    textTransform: "none",
                                    boxShadow: "none",
                                }}
                            >
                                {btn.label}
                            </Button>
                        ))}
                    </Box>
                )} */}
                {children}
            </Box>

        </Box>
    );
};

export default SectionCard;